import axios from '../../../../utills/axiosConfig';

export const fetchCategoryGroups = async () => {
  const res = await axios.get('/category-groups');
  return res.data;
};

export const addCategoryGroup = async (categoryGroup) => {
  try {
    const res = await axios.post('/category-groups', categoryGroup);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateCategoryGroup = async (id, categoryGroup) => {
  const res = await axios.put(`/category-groups/${id}`, categoryGroup);
  return res.data;
};

export const deleteCategoryGroup = async (id) => {
  const res = await axios.delete(`/category-groups/${id}`);
  return res.data;
};

export const importCategoryGroupCSV = async (formData) => {
  const { data } = await axios.post('/category-groups/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 